import { noop } from 'lodash';

import { BDTO } from '@helpful/network';
import { createContext } from 'use-context-selector';

import { FetchNextPageFn, RefetchFn, Filter } from './BenefitsProvider.types';

interface BenefitsProviderContextProps {
  refetch: RefetchFn;
  total: number;
  isLoading: boolean;
  hasNextPage: boolean;
  data: BDTO.PlanBenefitItem[];
  fetchNextPage: FetchNextPageFn;
  filter: Filter;
  filters: BDTO.GetPlanBenefitsParams;
  meta?: BDTO.GetPlanBenefitsMeta;
}

export const BenefitsProviderContext =
  createContext<BenefitsProviderContextProps>({
    total: 0,
    hasNextPage: false,
    isLoading: false,
    data: [],
    fetchNextPage: () => Promise.resolve(null),
    refetch: () => Promise.resolve(null),
    filter: noop,
    filters: {},
  });
